"use strict";

jQuery(document).ready(function ($) {
  var adpPopup = {};

  (function () {
    var $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",

      init: function () {
        $this = adpPopup;

        $this.markNewsletterPopups();
        $this.injectPopupNewsletterCss();

        // build header + fit title/email/description now and on resize
        $this.setupAllNewsletterHeaders();
        $this.fitAllNewsletterTitles();
        $this.sizeAllNewsletterEmailInputs();
        $this.fixAllNewsletterDescriptions();

        $(window)
          .off("resize.adpPopupLayoutFix")
          .on("resize.adpPopupLayoutFix", function () {
            $this.setupAllNewsletterHeaders();
            $this.fitAllNewsletterTitles();
            $this.sizeAllNewsletterEmailInputs();
            $this.fixAllNewsletterDescriptions();
          });

        $this.popupInit();
        $this.events();
      },

      markNewsletterPopups: function () {
        $(".popup").each(function (_, popup) {
          var $p = $(popup);
          if ($p.find(".newsletter-form").length > 0) {
            $p.addClass("adp-newsletter-popup");
          } else {
            $p.removeClass("adp-newsletter-popup");
          }
        });
      },

      // ----- HEADER: put title in the empty box left of the X -----

      getPopupTitleEl: function (popupEl) {
        var selectors = [
          ".popup-title",
          ".popup__title",
          ".popup-heading",
          ".popup-header__title",
          "h1",
          "h2",
        ];
        for (var i = 0; i < selectors.length; i++) {
          var el = popupEl.querySelector(selectors[i]);
          if (el) return el;
        }
        return null;
      },

      setupNewsletterHeader: function (popupEl) {
        if (!popupEl || !popupEl.classList.contains("adp-newsletter-popup")) return;

        var wrap = popupEl.querySelector(".popup-wrap");
        if (!wrap) return;

        var closeBtn = popupEl.querySelector(".popup-close");
        if (!closeBtn) return;

        var titleEl = $this.getPopupTitleEl(popupEl);
        if (!titleEl) return;

        // create header once
        var header = wrap.querySelector(".adp-popup-header");
        if (!header) {
          header = document.createElement("div");
          header.className = "adp-popup-header";
          wrap.insertBefore(header, wrap.firstChild);
        }

        // create title slot once
        var titleSlot = header.querySelector(".adp-popup-header__title");
        if (!titleSlot) {
          titleSlot = document.createElement("div");
          titleSlot.className = "adp-popup-header__title";
          header.appendChild(titleSlot);
        }

        // move title into header title slot
        if (titleEl.parentElement !== titleSlot) {
          titleSlot.appendChild(titleEl);
        }

        // move close button into header (right side)
        if (closeBtn.parentElement !== header) {
          header.appendChild(closeBtn);
        }
      },

      setupAllNewsletterHeaders: function () {
        $(".popup.adp-newsletter-popup").each(function (_, popup) {
          $this.setupNewsletterHeader(popup);
        });
      },

      // ----- TITLE: keep it one line and auto-fit inside header space (+2px max) -----

      fitTitleToOneLine: function (titleEl, maxPx, minPx) {
        if (!titleEl) return;

        var maxSize = typeof maxPx === "number" ? maxPx : 36;
        var minSize = typeof minPx === "number" ? minPx : 14;

        // ensure single line
        titleEl.style.whiteSpace = "nowrap";
        titleEl.style.overflow = "hidden";
        titleEl.style.textOverflow = "clip";
        titleEl.style.maxWidth = "100%";
        titleEl.style.textAlign = "center";

        // available width = header title slot width
        var slot = titleEl.closest(".adp-popup-header__title");
        if (!slot) return;
        var targetWidth = slot.clientWidth - 4;
        if (targetWidth <= 0) return;

        // start big, shrink until it fits
        var size = maxSize;
        titleEl.style.fontSize = size + "px";

        var safety = 120;
        while (titleEl.scrollWidth > targetWidth && size > minSize && safety-- > 0) {
          size -= 1;
          titleEl.style.fontSize = size + "px";
        }
      },

      fitAllNewsletterTitles: function () {
        $(".popup.adp-newsletter-popup").each(function (_, popup) {
          var titleEl = $this.getPopupTitleEl(popup);
          if (!titleEl) return;
          $this.fitTitleToOneLine(titleEl, 36, 14);
        });
      },

      // ----- EMAIL FONT: exactly 15% smaller than ORIGINAL (computed) -----

      sizeNewsletterEmailInput: function (popupEl) {
        if (!popupEl || !popupEl.classList.contains("adp-newsletter-popup")) return;

        var input =
          popupEl.querySelector('.newsletter-form input[type="email"]') ||
          popupEl.querySelector('.newsletter-form input[name="contact[email]"]');

        if (!input) return;

        // capture original computed size once (the "big original size")
        if (!input.dataset.adpBaseFontPx) {
          var cs = window.getComputedStyle(input);
          var base = parseFloat(cs.fontSize);
          if (!isNaN(base) && base > 0) input.dataset.adpBaseFontPx = String(base);
        }

        var basePx = parseFloat(input.dataset.adpBaseFontPx || "");
        if (isNaN(basePx) || basePx <= 0) return;

        var newPx = Math.round(basePx * 0.85 * 100) / 100; // 15% smaller
        input.style.fontSize = newPx + "px";
        input.style.lineHeight = "1.2";
      },

      sizeAllNewsletterEmailInputs: function () {
        $(".popup.adp-newsletter-popup").each(function (_, popup) {
          $this.sizeNewsletterEmailInput(popup);
        });
      },

      // ----- DESCRIPTION: reliably target the line between header and form, set +2px and FIX THE GAP -----

fixNewsletterDescription: function (popupEl) {
  if (!popupEl || !popupEl.classList.contains("adp-newsletter-popup")) return;

  var wrap = popupEl.querySelector(".popup-wrap");
  if (!wrap) return;

  var header = wrap.querySelector(".adp-popup-header");
  var form = wrap.querySelector(".newsletter-form");
  if (!header || !form) return;

  // Find the first paragraph-like element between header and form
  var candidates = wrap.querySelectorAll("p, .popup-description, .popup__description, .popup-text, div");
  var target = null;

  for (var i = 0; i < candidates.length; i++) {
    var el = candidates[i];

    // must be after header AND before form
    if (!(header.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
    if (!(el.compareDocumentPosition(form) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;

    // must contain the actual sentence text (non-empty)
    var txt = (el.textContent || "").replace(/\s+/g, " ").trim();
    if (!txt) continue;

    // avoid disclaimer line
    if (/unsubscribe anytime/i.test(txt) || /respect your inbox/i.test(txt)) continue;

    // prefer element that contains "Be first" or "Subscribe"
    if (/be first/i.test(txt) || /subscribe/i.test(txt)) {
      target = el;
      break;
    }

    // fallback: first reasonable text block before the form
    if (!target) target = el;
  }

  if (!target) return;

  // Apply inline styles with highest priority
  target.setAttribute('style', 
    'margin-top: 4px !important; ' +
    'margin-bottom: 4px !important; ' +
    'padding-top: 0 !important; ' +
    'padding-bottom: 0 !important; ' +
    'text-align: center !important;'
  );

  // make it +2px bigger than computed size
  if (!target.dataset.adpDescBasePx) {
    var cs = window.getComputedStyle(target);
    var base = parseFloat(cs.fontSize);
    if (!isNaN(base) && base > 0) target.dataset.adpDescBasePx = String(base);
  }
  var basePx = parseFloat(target.dataset.adpDescBasePx || "");
  if (!isNaN(basePx) && basePx > 0) {
    var currentStyle = target.getAttribute('style');
    target.setAttribute('style', currentStyle + ' font-size: ' + (basePx + 2) + 'px !important;');
  }

  // ALSO: remove extra top spacing on the first content block after header
  var afterHeader = header.nextElementSibling;
  if (afterHeader) {
    afterHeader.setAttribute('style', 
      (afterHeader.getAttribute('style') || '') + 
      ' margin-top: 0 !important; padding-top: 0 !important;'
    );
  }

  // Force the form to have no top margin/padding
  form.setAttribute('style',
    (form.getAttribute('style') || '') +
    ' margin-top: 0 !important; padding-top: 0 !important;'
  );
},

      fixAllNewsletterDescriptions: function () {
        $(".popup.adp-newsletter-popup").each(function (_, popup) {
          $this.fixNewsletterDescription(popup);
        });
      },

      // ----- CSS -----

      injectPopupNewsletterCss: function () {
        if (document.getElementById("adp-popup-newsletter-css")) return;

        var css = `
/* Only newsletter popups */
.popup.adp-newsletter-popup .popup-wrap{
  width: calc(100% - 40px) !important;
  max-width: 500px !important;
  padding-top: 0 !important;
  overflow-x: hidden !important;
}

/* Kill horizontal scroll anywhere inside */
.popup.adp-newsletter-popup,
.popup.adp-newsletter-popup .popup-wrap,
.popup.adp-newsletter-popup .popup-inner,
.popup.adp-newsletter-popup .popup__content,
.popup.adp-newsletter-popup .popup-content{
  overflow-x: hidden !important;
}

/* Header row (title left, X right) */
.popup.adp-newsletter-popup .adp-popup-header{
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px !important;
  padding: 14px 16px 4px !important;
  margin-bottom: 0 !important;
}

/* Force all paragraph-like elements between header and form to have minimal spacing */
.popup.adp-newsletter-popup .popup-wrap > p,
.popup.adp-newsletter-popup .popup-wrap > div > p,
.popup.adp-newsletter-popup .popup-description,
.popup.adp-newsletter-popup .popup__description,
.popup.adp-newsletter-popup .popup-text{
  margin-top: 4px !important;
  margin-bottom: 4px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* Remove top spacing from newsletter form */
.popup.adp-newsletter-popup .newsletter-form{
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Border around the email + subscribe row */
.popup.adp-newsletter-popup .newsletter-form__field-wrapper{
  border: 1px solid rgba(0,0,0,0.28) !important;
  padding: 12px 14px !important;
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 100% !important;
  margin-top: 0 !important;
}

/* Remove inner borders (single clean border) */
.popup.adp-newsletter-popup .newsletter-form__field-wrapper input,
.popup.adp-newsletter-popup .newsletter-form__field-wrapper button{
  border: 0 !important;
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
}

/* Prevent input from forcing overflow */
.popup.adp-newsletter-popup .newsletter-form__field-wrapper input{
  min-width: 0 !important;
  width: 100% !important;
}

/* Messages never overlap */
.popup.adp-newsletter-popup .newsletter-form__message.form__message,
.popup.adp-newsletter-popup .newsletter-form__message--success.form__message{
  position: static !important;
  float: none !important;
  display: block !important;
  width: 100% !important;
  clear: both !important;
  margin: 10px 0 0 !important;
  line-height: 1.35 !important;
}
        `.trim();

        var style = document.createElement("style");
        style.id = "adp-popup-newsletter-css";
        style.type = "text/css";
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
      },

      // ----- Events -----

      events: function () {
        $(document).off(".adpPopup");

        $(document).on("click.adpPopup", ".popup-close", $this.closePopup);
        $(document).on("click.adpPopup", ".popup-accept", $this.acceptPopup);
        $(document).on("click.adpPopup", ".popup-accept", $this.closePopup);

        $(document).on("click.adpPopup", ".age-verification__popup-close", $this.agePopup);
        $(document).on("click.adpPopup", ".age-verification__popup-close", $this.closePopup);
        $(document).on("click.adpPopup", ".age-verification__button-no", $this.ageDeclined);

        // Intercept POPUP newsletter forms only
        $(document).on("submit.adpPopup", ".popup .newsletter-form", $this.ajaxNewsletterSubmit);

        // Close via keys
        $(document).on("keyup.adpPopup", function (e) {
          if (e.key === "Escape") {
            $('.popup-open[data-esc-close="true"]').each(function (index, popup) {
              $this.closePopup(popup);
            });
          }
          if (e.key === "F4") {
            $('.popup-open[data-f4-close="true"]').each(function (index, popup) {
              $this.closePopup(popup);
            });
          }
        });

        // Close via overlay click
        $(document).on("click.adpPopup", ".popup-overlay", function () {
          $('.popup-open[data-overlay-close="true"]').each(function (index, popup) {
            $this.closePopup(popup);
          });
        });
      },

      // ----- AJAX newsletter submit (your existing logic) -----

      ajaxNewsletterSubmit: function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        var form = evt.currentTarget;
        var $form = $(form);
        var $popup = $form.closest(".popup");

        if ($form.data("submitting")) return false;
        $form.data("submitting", true);

        var $btn = $form.find('button[type="submit"]');
        $btn.prop("disabled", true);

        $form.find(".newsletter-form__message.form__message").remove();
        $form.find(".newsletter-form__message--success").remove();

        if ($form.find('input[name="contact[accepts_marketing]"]').length === 0) {
          $form.append('<input type="hidden" name="contact[accepts_marketing]" value="true">');
        }

        var rawAction = form.getAttribute("action") || window.location.pathname;
        var actionUrl = rawAction.split("#")[0];

        fetch(actionUrl, {
          method: "POST",
          body: new FormData(form),
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" }
        })
          .then(function (res) {
            return res.text().then(function (html) {
              var url = res.url || "";
              var urlSuccess =
                url.indexOf("customer_posted=true") !== -1 ||
                url.indexOf("contact_posted=true") !== -1;

              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");

              var errEl =
                doc.querySelector('[id^="Newsletter-error"]') ||
                doc.querySelector(".newsletter-form__message.form__message") ||
                doc.querySelector(".form__message");

              var errText = errEl ? (errEl.textContent || "").replace(/\s+/g, " ").trim() : "";
              var hasError = !!errText;

              return { success: urlSuccess && !hasError, errorText: errText };
            });
          })
          .then(function (payload) {
            var $wrapper = $form.find(".newsletter-form__field-wrapper").first();

            if (!payload.success) {
              var msg = payload.errorText && payload.errorText.length
                ? payload.errorText
                : "Please enter a valid email address.";

              $('<small class="newsletter-form__message form__message" role="alert">' +
                $this.escapeHtml(msg) +
                "</small>").insertAfter($wrapper);

              return;
            }

            form.reset();

            $('<h3 class="newsletter-form__message newsletter-form__message--success form__message" tabindex="-1">' +
              "Thanks for subscribing!" +
              "</h3>").insertAfter($wrapper);

            $form.find(".newsletter-form__message--success").focus();

            var popupId = $popup.data("id") || 0;
            $this.setCookie("popup-accept-" + popupId, 1, { expires: 360 });

            $(document).trigger("adp:popup:email_success", [$popup[0], form]);

            // re-apply 15% sizing after reset + re-fix description spacing
            $this.sizeAllNewsletterEmailInputs();
            $this.fixAllNewsletterDescriptions();
          })
          .catch(function () {
            var $wrapper = $form.find(".newsletter-form__field-wrapper").first();
            $('<small class="newsletter-form__message form__message" role="alert">' +
              "Something went wrong. Please try again." +
              "</small>").insertAfter($wrapper);
          })
          .finally(function () {
            $form.data("submitting", false);
            $btn.prop("disabled", false);
          });

        return false;
      },

      // ----- Popup init / open / close -----

      popupInit: function () {
        $(document)
          .off("scroll.adpPopupScroll")
          .on("scroll.adpPopupScroll", function () {
            var scrollCurrent = window.scrollY;
            $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
            $this.sPrevious = scrollCurrent;
          });

        $(".popup").each(function (index, popup) {
          if ("manual" === $(popup).data("open-trigger")) {
            var selector = $(popup).data("open-manual-selector");

            if (selector) {
              $(selector).addClass("popup-trigger");

              $(document)
                .off("click.adpPopupManual_" + index)
                .on("click.adpPopupManual_" + index, selector, function (e) {
                  e.preventDefault();

                  $(popup).removeClass("popup-already-opened");

                  if (
                    e.currentTarget.classList.contains("popup") ||
                    $(e.currentTarget).parents(".popup").length > 0
                  ) {
                    $this.closePopup(selector);
                  }

                  $this.openPopup(popup);
                });
            }
          }

          if (
            !$this.isAllowPopup(popup) &&
            !$(popup).hasClass("age-verification")
          ) {
            return;
          }

          $this.openTriggerPopup(popup);
        });
      },

      openTriggerPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;

        var trigger = $(popup).data("open-trigger");
        var popupId = $(popup).data("id") || 0;

        if ("none" === trigger) {
          var ageVerification = $this.getCookie("popup-age-" + popupId);
          if (!ageVerification) $this.openPopup(popup);
        }

        if ("delay" === trigger) {
          setTimeout(function () {
            $this.openPopup(popup);
          }, (Number($(popup).data("open-delay-number")) || 0) * 1000);
        }

        if ("exit" === trigger) {
          var showExit = true;
          document.addEventListener("mousemove", function (evt) {
            var scroll = window.pageYOffset || document.documentElement.scrollTop;
            if (evt.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }

        if ("scroll" === trigger) {
          var pointScrollType = $(popup).data("open-scroll-type");
          var pointScrollPosition = Number($(popup).data("open-scroll-position")) || 0;

          $(document)
            .off("scroll.adpPopupOpen_" + popupId)
            .on("scroll.adpPopupOpen_" + popupId, function () {
              if ("px" === pointScrollType) {
                if (window.scrollY >= pointScrollPosition) $this.openPopup(popup);
              }
              if ("%" === pointScrollType) {
                if ($this.getScrollPercent() >= pointScrollPosition) $this.openPopup(popup);
              }
            });
        }

        if ("accept" === trigger) {
          var accept = $this.getCookie("popup-accept-" + popupId);
          if (!accept) $this.openPopup(popup);
        }
      },

      openPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;

        if ($(popup).is('[data-body-scroll-disable="true"]')) {
          $("body").addClass("popup-scroll-hidden");
        }

        var popupId = $(popup).data("id") || 0;

        var limit = parseInt($this.getCookie("popup-" + popupId) || 0, 10) + 1;
        $this.setCookie("popup-" + popupId, limit, {
          expires: $(popup).data("limit-lifetime"),
        });

        if ($(popup).hasClass("popup-open")) return;
        if ($(popup).hasClass("popup-already-opened")) return;

        $(popup).addClass("popup-open");

        $(popup).data("init-scroll-px", window.scrollY);
        $(popup).data("init-scroll-percent", $this.getScrollPercent());

        // build header and apply sizing + FIX description spacing
        $this.setupNewsletterHeader(popup);
        $this.fitAllNewsletterTitles();
        $this.sizeAllNewsletterEmailInputs();
        $this.fixNewsletterDescription(popup);

        var animation = $(popup).data("open-animation");
        $this.applyAnimation(popup, animation);

        if ($(popup).find(".newsletter-form").length === 0) {
          $this.closeTriggerPopup(popup);
        }
      },

      closeTriggerPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;

        // never auto-close newsletter popups
        if ($(popup).find(".newsletter-form").length > 0) return;

        var trigger = $(popup).data("close-trigger");
        var popupId = $(popup).data("id") || 0;

        if ("delay" === trigger) {
          setTimeout(function () {
            $this.closePopup(popup);
          }, (Number($(popup).data("close-delay-number")) || 0) * 1000);
        }

        if ("scroll" === trigger) {
          var pointScrollType = $(popup).data("close-scroll-type");
          var pointScrollPosition = Number($(popup).data("close-scroll-position")) || 0;
          var initScrollPx = Number($(popup).data("init-scroll-px")) || 0;
          var initScrollPercent = Number($(popup).data("init-scroll-percent")) || 0;

          $(document)
            .off("scroll.adpPopupClose_" + popupId)
            .on("scroll.adpPopupClose_" + popupId, function () {
              if ("px" === pointScrollType) {
                if ("up" === $this.sDirection && window.scrollY < initScrollPx - pointScrollPosition)
                  $this.closePopup(popup);

                if ("down" === $this.sDirection && window.scrollY >= initScrollPx + pointScrollPosition)
                  $this.closePopup(popup);
              }

              if ("%" === pointScrollType) {
                if ("up" === $this.sDirection && $this.getScrollPercent() < initScrollPercent - pointScrollPosition)
                  $this.closePopup(popup);

                if ("down" === $this.sDirection && $this.getScrollPercent() >= initScrollPercent + pointScrollPosition)
                  $this.closePopup(popup);
              }
            });
        }
      },

      agePopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        var popupId = $(popup).data("id") || 0;

        $this.setCookie("popup-age-" + popupId, 1, { expires: 360 });
      },

      ageDeclined: function () {
        $(".age-verification__question").removeClass("show");
        $(".age-verification__declined").addClass("show");
      },

      acceptPopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        var popupId = $(popup).data("id") || 0;

        $this.setCookie("popup-accept-" + popupId, 1, { expires: 360 });
      },

      closePopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        var animation = $(popup).data("exit-animation");

        $this.applyAnimation(popup, animation, function () {
          $(popup).addClass("popup-already-opened");
          $(popup).removeClass("popup-open");
        });

        $("body").removeClass("popup-scroll-hidden");
      },

      isAllowPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;

        var limitDisplay = parseInt($(popup).data("limit-display") || 0, 10);
        var popupId = $(popup).data("id") || 0;

        var limitDisplayCookie = parseInt($this.getCookie("popup-" + popupId) || 0, 10);

        if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) {
          return false;
        }

        return true;
      },

      applyAnimation: function (el, name, callback) {
        var popup = $(el).closest(".popup");
        var overlayName = typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

        $(popup)
          .next(".popup-overlay")
          .addClass("popup-animated " + overlayName)
          .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
            $(this).removeClass("popup-animated " + overlayName);
          });

        $(popup)
          .find(".popup-wrap")
          .addClass("popup-animated " + name)
          .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
            $(this).removeClass("popup-animated " + name);
            if (typeof callback === "function") callback();
          });
      },

      getCookie: function (name) {
        var matches = document.cookie.match(
          new RegExp(
            "(?:^|; )" +
              name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
              "=([^;]*)"
          )
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
      },

      setCookie: function (name, value, options) {
        options = options || {};
        options.path = options.hasOwnProperty("path") ? options.path : "/";
        options.expires = parseInt(options.expires, 10);

        if (typeof options.expires === "number" && options.expires) {
          options.expires = new Date().setDate(new Date().getDate() + options.expires);
          options.expires = new Date(options.expires).toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + "=" + value;

        for (var propName in options) {
          updatedCookie += "; " + propName;
          var propValue = options[propName];
          if (propValue !== true) updatedCookie += "=" + propValue;
        }

        document.cookie = updatedCookie;
      },

      getScrollPercent: function () {
        var h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      },

      escapeHtml: function (str) {
        return String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
      },
    };
  })();

  // Initialize.
  adpPopup.init();

  document.addEventListener("shopify:section:load", function () {
    adpPopup.init();
  });
});